<script lang="ts" setup>
import type { ProductAttributeValueSlotDto } from '@repo/api/web/models'

const props = defineProps<{
  attribute: ProductAttributeValueSlotDto
}>()

const displayValue = computed(() => {
  const first = props.attribute.values[0]
  return first?.displayName || first?.value || null
})
</script>

<template>
  <UiAttribute
    :label="props.attribute.metadata.displayName"
    :content="displayValue"
    :ui="{ label: 'text-muted text-sm' }"
  />
</template>
